<div>
  <h1 mat-dialog-title class="token-expiration">Token Expiration Warning</h1>
  <div mat-dialog-content>
    <p>Your user token is about to expire.</p>
    <p>
      You will be automatically logged off of the system
      <span *ngIf="timeRemainingString"
        >in <b>{{ timeRemainingString }}</b
        >.</span
      >
      <span *ngIf="!timeRemainingString">in a few moments.</span>
    </p>
    <p>Please complete any work in progress.</p>
  </div>
  <div mat-dialog-actions class="d-flex align-items-center">
    <button mat-stroked-button color="accent" (click)="onClickStay()">Okay</button>
    <button mat-raised-button color="primary" class="ml-2" (click)="onClickLogout()">Logout</button>
  </div>
</div>
